import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'recertification',
});

export const submitRouteRef = createRouteRef({
  id: 'recertification:submit',
  params: ['type', 'resourceId'],
});

export const bulkSubmitRouteRef = createRouteRef({
  id: 'recertification:bulk-submit',
  params: ['type'],
});
